import "./EndGamePage.css";
import { Button } from "@mui/material";

import UserDetailsForm from "../UserDetailsForm/UserDetailsForm";
import { useEffect, useState } from "react";
import Prizes from "../Prizes/Prizes";
import { useNavigate } from "react-router-dom";
import { addZerosToScore } from "../../utills";

function EndGamePage({ score }) {
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const navigteToGame = () => {
    navigate("/game");
  };
  useEffect(() => {
    const attachRandomMessage = () => {
      const randomNum = Math.floor(Math.random() * 4);
      switch (randomNum) {
        case 1:
          setMessage("יש לכם את הטאץ׳!");

          break;
        case 2:
          setMessage(" קחו, נפל לכם הכתר");

          break;

        default:
          setMessage("נתתם פה שואו!");
      }
    };
    attachRandomMessage();
  }, []);

  return (
    <div className="background  ">
      <div className="block"></div>
      <div className="end-game-container ">
        <div className="end-game_inner-container">
          <img
            className="keff-logo"
            src={process.env.PUBLIC_URL + "Assets/Keff_logo.png"}
            alt="keff_logo"
          ></img>
          <h2 className="end-game-message">{message}</h2>
          <div className="score-box">
            <div className="second-section">
              <p className="score">{addZerosToScore(score)}</p>
            </div>
            <div className="first-section">
              <p className="score-text">הניקוד שלכם</p>
            </div>
          </div>
          <div className="end-game-prizes-txt-container">
            <p>השאירו כמה פרטים קטנים</p>
            <div className="end-game-prizes-txt">
              <Prizes />
              <p>ואולי תוכלו לזכות</p>
            </div>
          </div>
          <UserDetailsForm score={score} />
          <Button
            className="thank-you-bt"
            variant="outline"
            onClick={navigteToGame}
            sx={{
              "&:hover": {
                backgroundColor: "#79c9f2",
                color: "#fff",
              },
              margin: "0 0 10px 0",
              fontWeight: "900",
              border:`2px solid #79c9f2 !important`,
              width:'150px',
              height: '40px'

              
            }}
          >
            <span className="play-again-text">שחקו שוב</span>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default EndGamePage;
